import script from "./bottomView.vue?vue&type=script&setup=true&name=bottomView&lang=js"
export * from "./bottomView.vue?vue&type=script&setup=true&name=bottomView&lang=js"

import "./bottomView.vue?vue&type=style&index=0&id=67ca857c&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67ca857c"]])

export default __exports__